/* eslint-disable */
import React, { Component } from 'react';

class ServicesDescription extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <div className="" />;
  }
}

export default ServicesDescription;



// WEBPACK FOOTER //
// ./src/components/Views/OnboardingVirtualMembers/Steps/ServicesDescriptionVirtualMember.js